import { useEffect, useRef } from "react";
import { track } from "@/lib/track";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// Handles the Google OAuth redirect: exchanges the code (via our backend) and signs the user in.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");

    if (error || !code) {
      toast.error("Google sign-in was cancelled.");
      nav("/login", { replace: true });
      return;
    }
    const savedState = sessionStorage.getItem("g_oauth_state");
    if (savedState && state && savedState !== state) {
      toast.error("Sign-in failed (security check). Please try again.");
      nav("/login", { replace: true });
      return;
    }
    sessionStorage.removeItem("g_oauth_state");

    const redirectUri = window.location.origin + "/auth/google";
    api
      .post("/auth/google", { code, redirect_uri: redirectUri })
      .then(async ({ data }) => {
        setToken(data.token, true);
        if (data.is_new) track("CompleteRegistration", "sign_up", { method: "google" });
        await refresh();
        toast.success("Signed in with Google.");
        nav("/app", { replace: true });
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || "Google sign-in failed.");
        nav("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <Loader2 size={32} className="animate-spin text-[#7C5CFF]" />
      <p className="text-[14px] text-[#8E8B99]">Signing you in with Google…</p>
    </div>
  );
}
